import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { IBalanceProps } from '../../types';
import { PaymentStatusContainer } from '../PaymentStatus';
import { MoneySourceContainer } from '../MoneySource';
import * as styles from './BalanceMobile.css';

export const BalanceMobile = (props: IBalanceProps) => {
  const { withMoneySource, showBalance, withPay, balanceString, handleDepositLinkClick } = props;

  return (
    <>
      {withMoneySource && <MoneySourceContainer />}

      {showBalance && (
        <div className={styles['balance_wrapper']}>
          <ArticleParagraph1>Баланс</ArticleParagraph1>

          {balanceString && (
            <ArticleParagraph1 as="div" textAlign="right">
              <div className={styles['balance']}>{balanceString}</div>

              {withPay && <Link onClick={handleDepositLinkClick}>Пополнить</Link>}
            </ArticleParagraph1>
          )}
        </div>
      )}

      <PaymentStatusContainer />
    </>
  );
};
